<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              <div class="select col">
                <select v-model="makeup_location_id">
                  <option value="">Makeup Location</option>
                  <option :value="row.id" v-for="row in makeuplocations" :key="row.id">{{ row.name }}</option>
                 
                </select>
              </div>
            

             <div class=" col">
                &nbsp;<input type="date" class="input" v-model="start_date" />
                
              </div>
              <div class=" col" >
                &nbsp;<input type="date" class="input" v-model="end_date" />
                
              </div>

              <div class="col">
                  <table class="table is-hoverable is-bordered " id="overviewtable" >
                    <tbody>
                      <tr>
                        <td class="">Total Orders</td>
                        <td>{{ entries.length }}</td>
                        <td class="">Total Garments</td>
                        <td>{{ this.total_qty }}</td>
                       
                        </tr>
                    </tbody>
                  </table>
                </div>
            </div>
      </div>
        
      </div>
      <div class="notification is-info" v-if="loading == true">Loading data ...</div>

    <table class="table is-hoverable is-fullwidth is-size-7" id="entriestable" v-if="loading == false && entries.length > 0">
    	<thead>
    		<tr>
          <th>Date Processed</th>
          <th>Order Number </th>
          <th>Date Required </th>
          <th>Client </th>
          <th>Garment </th>
          <th>Design Name </th>
        <th>Kids </th>
          <th>Adults </th>
        <th>Makeup</th>
        
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="order in entries" v-bind:key="order.id" >
          <td >{{ order.date }}</td>
          <td >{{ order.ponumber }}</td>
          <td >{{ order.deliverydate_raw }}</td>
          <td >{{ order.clientname }} </td>
          <td >{{ order.garmentname }} </td>
          <td >{{ order.designname }} </td>
          <td>{{order.kids_qty}}</td>
          <td>{{order.adults_qty}}</td>
          <td>
            {{ order.makeup_location_name}}
          </td>

         
              
			</tr>
    	</tbody>
    </table>
    


    <button @click="exportXLS()" class="button is-info" v-if="loading==false">Export to Excel</button>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";
import XLSX from 'xlsx';

export default {
  name:'PrintingCuttingSummary',
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
     entries: [],
     area: 'printing_papers',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      loading: true,
     accessToken: '',
     makeuplocations: [],
     makeup_location_id: ''
     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getMakeupLocations();
            this.getData()
        });
      
    },
  methods: {
    
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('entriestable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Printing Processed Report.xlsx')

	 },
   
    async getData() {
      this.loading=true;
      OrderService.getPrintingProcessedReportData(this.accessToken, this.start_date, this.end_date, this.makeup_location_id)
          .then(
            (entries => {
              
              this.$set(this, "entries", entries);
              this.loading=false;
            }).bind(this)
          );
      
    },
   
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },

        
   
  },
  computed : {
     
    
      total_qty: function() {
        return this.entries.reduce((total, item) => total + item.total_qty, 0);
      },
      
      

  },

 
  mounted() {
    
  },
  watch: {
    makeup_location_id: function () {
      this.entries = []
      this.getData()
    },
    start_date: function () {
      this.entries = []
      this.getData()
    },
    end_date: function () {
      this.entries = []
      this.getData()
    },
  }
}



</script>


